import React from 'react';
import { CreditCard, Calendar, Percent, RefreshCw } from 'lucide-react';

const InvestmentParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  compoundingFrequencies,
  investmentTypes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Начальная сумма инвестиции */}
      <div>
        <label htmlFor="initialInvestment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-indigo-500" />
          Начальная сумма
        </label>
        <input
          type="text"
          id="initialInvestment"
          name="initialInvestment"
          value={formData.initialInvestment}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.initialInvestment ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.initialInvestment && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.initialInvestment}
          </p>
        )}
      </div>

      {/* Срок инвестирования */}
      <div>
        <label htmlFor="investmentTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Срок инвестирования (лет)
        </label>
        <input
          type="text"
          id="investmentTerm"
          name="investmentTerm"
          value={formData.investmentTerm}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.investmentTerm ? 'input-error' : ''}`}
          placeholder="Введите срок"
        />
        {errors.investmentTerm && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.investmentTerm}
          </p>
        )}
      </div>

      {/* Годовая процентная ставка */}
      <div>
        <label htmlFor="interestRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Percent className="w-4 h-4 mr-2 text-indigo-500" />
          Годовая процентная ставка (%)
        </label>
        <input
          type="text"
          id="interestRate"
          name="interestRate"
          value={formData.interestRate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.interestRate ? 'input-error' : ''}`}
          placeholder="Введите ставку"
        />
        {errors.interestRate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.interestRate}
          </p>
        )}
        <div className="mt-2 grid grid-cols-3 gap-1">
          {investmentTypes.slice(0, 3).map(type => (
            <button
              key={type.id}
              type="button"
              onClick={() => handleInputChange({
                target: { name: 'interestRate', value: type.defaultRate.toString() }
              })}
              className="text-xs px-2 py-1 rounded border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              {type.name}: {type.defaultRate}%
            </button>
          ))}
        </div>
      </div>

      {/* Периодичность капитализации */}
      <div>
        <label htmlFor="compoundingFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <RefreshCw className="w-4 h-4 mr-2 text-indigo-500" />
          Периодичность капитализации
        </label>
        <select
          id="compoundingFrequency"
          name="compoundingFrequency"
          value={formData.compoundingFrequency}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {compoundingFrequencies.map((frequency) => (
            <option key={frequency.id} value={frequency.id}>
              {frequency.name}
            </option>
          ))}
        </select>
        {errors.compoundingFrequency && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.compoundingFrequency}
          </p>
        )}
      </div>

      {/* Дата начала инвестиции */}
      <div>
        <label htmlFor="investmentStartDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Дата начала инвестиции
        </label>
        <input
          type="date"
          id="investmentStartDate"
          name="investmentStartDate"
          value={formData.investmentStartDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.investmentStartDate ? 'input-error' : ''}`}
        />
        {errors.investmentStartDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.investmentStartDate}
          </p>
        )}
      </div>

      {/* Реинвестировать дивиденды */}
      <div className="col-span-full">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="reinvestDividends"
            checked={formData.reinvestDividends}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Реинвестировать дивиденды и проценты (DRIP)
          </span>
        </label>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Автоматическое реинвестирование полученных дивидендов и процентов для дополнительного роста
        </p>
      </div>
    </div>
  );
};

export default InvestmentParametersSection;